// Maps a booking status to the .mb-pill colour modifier used in the bookings list.
export function Booking_Status_Class(status: string): string {
    const value = (status ?? "").toLowerCase();
    if (value.includes('cancel')) {
        return 'is-warning';
    }
    if (value.includes('confirm') || value.includes('paid') || value.includes('complete')) {
        return 'is-success';
    }
    if (value.includes('provisional') || value.includes('pending') || value.includes('hold') || value.includes('quote')) {
        return 'is-notice';
    }
    return 'is-accent';
}
